<template>
  <el-menu router
           :default-active="$route.path"
           :collapse-transition="false"
           background-color="#272727"
           text-color="#939393"
           class="el-menu-vertical-demo">
    <el-submenu index="1">
      <template slot="title">
        <i class="iconfont">&#xeabb;</i>
        <span>站点管理</span>
      </template>
      <el-menu-item index="/website/home">国内</el-menu-item>
      <el-menu-item index="/website/oversae">海外</el-menu-item>
    </el-submenu>
  </el-menu>
</template>
<script>
export default {
  name: 'website-nav',
};
</script>
<style lang="less">
.el-submenu .el-menu-item {
  padding: 0;
  min-width: 160px;
}
</style>

<style lang="less" scoped>
.el-menu {
  height: 100%;
  color: #fff;
  border: none;
}

.el-aside {
  overflow: inherit;
  background-color: #272727;
  .logo {
    height: 50px;
    background: #000;
    font-size: 16px;
    color: #fff;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
    .iconfont {
      font-size: 20px;
      margin-right: 8px;
      &.collapse {
        margin-right: 0;
      }
    }
  }
  .el-menu-item {
    color: #fff;
    height: 50px;
    line-height: 50px;
    user-select: none;
  }
  .el-menu-item.is-active {
    color: #fff;
    background-color: #409eff !important;
  }
  .el-menu-item:focus,
  .el-menu-item:hover {
    color: #fff;
    background-color: #409eff !important;
  }
  .el-menu--horizontal > .el-menu-item:focus,
  .el-menu--horizontal > .el-menu-item:hover {
    background-color: #000;
    color: #fff;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    color: #409eff;
  }
  .el-menu--horizontal > .el-menu-item {
    color: #303133;
  }
  .aside {
    height: ~"calc(100vh - 50px)";
    .el-menu {
      height: ~"calc(100vh - 70px)";
    }
    .mini_menu {
      li {
        text-align: center;
        height: 56px;
        line-height: 56px;
      }
      i {
        color: #fff;
        font-size: 16px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WebsiteNav.vue